module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/home/gustavom/fabacus/redemption-campaign-chintiandparker-cpa/src/intl","languages":["en"],"defaultLanguage":"en","redirect":false},
    }]
